import React from 'react';
import KpiCardsContainer from '../KpiCardsContainer/KpiCardsContainer';
import FiltersSection from '../FilterSection/FiltersSection';
import { IDataInsightsContentProps } from './types';
import { ChartsContainer } from '../ChartsContainer/ChartsContainer';
import { AnalyticsContentWrapper } from './AnalyticsContent.style';
import { useAnalyticsUrlFilters } from '../../hooks/useAnalyticsUrlFilters';

export const AnalyticsContent = ({ shopId }: IDataInsightsContentProps) => {
  const { timeRange, setTimeRange, product, setProduct, device, setDevice } =
    useAnalyticsUrlFilters();

  return (
    <AnalyticsContentWrapper>
      <FiltersSection
        timeRange={timeRange}
        setTimeRange={setTimeRange}
        product={product}
        setProduct={setProduct}
        device={device}
        setDevice={setDevice}
        shopId={shopId}
      />
      <KpiCardsContainer timeRange={timeRange} product={product} device={device} shopId={shopId} />
      <ChartsContainer timeRange={timeRange} product={product} device={device} shopId={shopId} />
    </AnalyticsContentWrapper>
  );
};
